export default "__VITE_ASSET__zs7Fs4P5__"